// extracted by mini-css-extract-plugin
export default {"modalShadow":"modalui_modalShadow__eSG4M","modalui":"modalui_modalui__kCSfh"};